import { render, staticRenderFns } from "./PedidoGeneral.vue?vue&type=template&id=187e4ce6&"
import script from "./PedidoGeneral.vue?vue&type=script&lang=js&"
export * from "./PedidoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports